import React from "react";
import styled from "styled-components";

function MainLayout(props) {
  return (
    <>
      <MainLayoutWrapper
        style={{
          ...props.style,
        }}
      >
        {props.children}
      </MainLayoutWrapper>
    </>
  );
}

export default MainLayout;

const MainLayoutWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: auto;
  display: flex;
  gap: 15.8%;
  position: relative;
`;
